var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToroSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 24,
    viewBox: "0 0 132 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6445 9.00031H41.2919V19.5978H41.3474C44.3671 19.5978 46.8153 17.2931 46.8153 14.4499V9.00031H54.6752V4.60034H33.6445V9.00031Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2564 15.2H65.0003C63.1671 15.2 61.583 13.8767 61.4974 12.1526C61.4064 10.3192 62.9644 8.7999 64.8927 8.7999H70.1486C71.9818 8.7999 73.5661 10.1234 73.6515 11.8473C73.7424 13.6812 72.1842 15.2 70.2564 15.2ZM71.5554 4.40015H63.5939C59.154 4.40015 55.5215 7.82005 55.5215 11.9999C55.5215 16.1798 59.154 19.5999 63.5939 19.5999H71.5554C75.9951 19.5999 79.6278 16.1798 79.6278 11.9999C79.6278 7.82005 75.9951 4.40015 71.5554 4.40015Z",
    fill: "#141414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.337 15.2H117.081C115.247 15.2 113.663 13.8767 113.577 12.1526C113.486 10.3192 115.045 8.7999 116.973 8.7999H122.229C124.062 8.7999 125.646 10.1234 125.732 11.8473C125.823 13.6812 124.264 15.2 122.337 15.2ZM123.635 4.40015H115.674C111.234 4.40015 107.602 7.82005 107.602 11.9999C107.602 16.1798 111.234 19.5999 115.674 19.5999H123.635C128.075 19.5999 131.708 16.1798 131.708 11.9999C131.708 7.82005 128.075 4.40015 123.635 4.40015Z",
    fill: "#141414"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7275 10.0145C98.7275 10.7765 98.065 11.4004 97.2551 11.4004H89.8044V8.60059H97.2551C98.065 8.60059 98.7275 9.22429 98.7275 9.98677V10.0145ZM104.321 10.242C104.321 8.74525 103.672 7.3852 102.622 6.39695C101.575 5.41098 100.13 4.79932 98.5404 4.79932H83.6445V13.2515V15.7999V19.3993H89.592V15.7999H95.88L98.0859 19.3993H104.321L101.647 14.8258C103.251 13.8555 104.321 12.1606 104.321 10.242Z",
    fill: "#141414"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4015 23.9217V17.9512C12.4015 17.8869 12.3243 17.8503 12.2693 17.8887C9.12343 20.086 5.54305 22.0893 1.60587 23.8513C1.52626 23.8872 1.55328 23.9999 1.64157 23.9999H12.3185C12.3644 23.9999 12.4015 23.9647 12.4015 23.9217Z",
    fill: "#EC0000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1462 0.123332C25.185 0.0715461 25.1455 0 25.0784 0H8.86189C4.12955 0 0.292969 3.58208 0.292969 8.00067V15.4908C0.292969 15.5444 0.348938 15.5821 0.402737 15.5648C11.465 12.0572 20.2732 6.58474 25.1462 0.123332Z",
    fill: "#EC0000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8633 14.4646V23.9219C16.8633 23.9648 16.9004 23.9998 16.9463 23.9998H17.217C21.949 23.9998 25.7854 20.4179 25.7854 15.9993V2.20363C25.7854 2.11573 25.6549 2.09484 25.6242 2.17797C24.0221 6.53751 21.0207 10.6786 16.8886 14.4085C16.8724 14.423 16.8633 14.4432 16.8633 14.4646Z",
    fill: "#EC0000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4015 23.9217V17.9512C12.4015 17.8869 12.3243 17.8503 12.2693 17.8887C9.12343 20.086 5.54305 22.0893 1.60587 23.8513C1.52626 23.8872 1.55328 23.9999 1.64157 23.9999H12.3185C12.3644 23.9999 12.4015 23.9647 12.4015 23.9217Z",
    fill: "#EC0000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1462 0.123332C25.185 0.0715461 25.1455 0 25.0784 0H8.86189C4.12955 0 0.292969 3.58208 0.292969 8.00067V15.4908C0.292969 15.5444 0.348938 15.5821 0.402737 15.5648C11.465 12.0572 20.2732 6.58474 25.1462 0.123332Z",
    fill: "#EC0000"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8633 14.4646V23.9219C16.8633 23.9648 16.9004 23.9998 16.9463 23.9998H17.217C21.949 23.9998 25.7854 20.4179 25.7854 15.9993V2.20363C25.7854 2.11573 25.6549 2.09484 25.6242 2.17797C24.0221 6.53751 21.0207 10.6786 16.8886 14.4085C16.8724 14.423 16.8633 14.4432 16.8633 14.4646Z",
    fill: "#EC0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToroSmall);
export default __webpack_public_path__ + "static/media/toro-small.3507f8c22ab72c6570a8b5bfde74afea.svg";
export { ForwardRef as ReactComponent };